module.exports = __webpack_public_path__ + "img/eye-in-gdpr-en.99a66250.webp";